document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.site-header').forEach(function (header) {
    var sectionId = header.getAttribute('data-section-id');
    var isTransparent = header.getAttribute('data-transparent') === 'true';

    var menuToggle = header.querySelector('.site-header__menu-toggle');
    var drawer = document.getElementById('SiteMenuDrawer-' + sectionId);
    var searchToggle = header.querySelector('.site-header__search-toggle');
    var searchPanel = document.getElementById('SiteSearchPanel-' + sectionId);
    var searchClose = searchPanel ? searchPanel.querySelector('.site-search-panel__close') : null;
    var searchInput = searchPanel ? searchPanel.querySelector('.site-search-panel__input') : null;

    // --- Menu drawer open/close ---
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (menuToggle && drawer) {
      menuToggle.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    }

    // --- Search panel open/close ---
    function openSearch() {
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    }
    function closeSearch() {
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        if (searchPanel.hidden) {
          openSearch();
        } else {
          closeSearch();
        }
      });
      if (searchClose) searchClose.addEventListener('click', closeSearch);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSearch();
      });
    }

    // --- Sticky / transparent scroll behavior ---
    if (isTransparent) {
      var scrollThreshold = 60;
      function updateScrollState() {
        if (window.scrollY > scrollThreshold) {
          header.classList.add('site-header--scrolled');
        } else {
          header.classList.remove('site-header--scrolled');
        }
      }
      updateScrollState();
      window.addEventListener('scroll', updateScrollState, { passive: true });
    }
  });
});
